<script>
import Base from '@/plans/ZOOM_CLIPS/config/base';
import { isLastPlanTypeInPlantypeList } from '@/utils/index.js';
import { planTypes } from '@/common/constants';
import { flowTypes } from '@/common/service/page-config';

export default {
  name: 'ZoomClipsPlusBuyNow',
  extends: Base,
  computed: {
    canRmv() {
      if (this.soft_bundle_hiddenRemoveBtn) return false;
      // special case: Zoom clips can be the base plan of custom avatars even if it's a standalone product
      if (
        this.$query.from === planTypes.CUSTOM_AVATARS &&
        /^(zclips|clips)$/.test(this.$query.plan)
      ) {
        return false;
      }
      return this.$context.is.winback || this.$context.is.fromCampaignLink
        ? !isLastPlanTypeInPlantypeList(
            this.planType,
            this.getSelectedPlans.map((p) => p.type),
          )
        : this.$context.type !== this.planType;
    },
    alertMsg() {
      if ([planTypes.CUSTOM_AVATARS].includes(this.$context.type)) {
        return this.$t('billing.custom_avatars.zoom_meeting_alert_desc', ['Zoom Workplace Pro']);
      }
      return '';
    },

    showSwitchToMeeting() {
      return (
        [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        this.$query.from === planTypes.CUSTOM_AVATARS
      );
    },
  },
};
</script>
